import type { HTMLAttributes, ReactNode } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  title?: string;
}

export function Card({ children, title, className = '', ...rest }: Props) {
  return (
    <div
      {...rest}
      className={`rounded-xl border border-slate-200 bg-white p-5 shadow-sm ${className}`}
    >
      {title ? (
        <h3 className="mb-3 text-base font-semibold text-slate-900">{title}</h3>
      ) : null}
      {children}
    </div>
  );
}
